<template>
  <div class="card">
    <h6>YOUR NEW TARIFF</h6>
    <h4>How do you want to pay for you new {{ quote.compareFuel === 'gasElectricity' ? 'gas & electricity' :
      quote.compareFuel }} tariff?</h4>

    <div class="row">
      <div class="col-xs-6 col-md-3">
        <radio-button v-model="quote.newTariffPaymentMethod" value="monthlyDirectDebit"
          :error="$v.newTariffPaymentMethod.$error">Monthly Direct Debit</radio-button>
      </div>

      <div class="col-xs-6 col-md-3">
        <radio-button v-model="quote.newTariffPaymentMethod" value="quarterlyDirectDebit"
          :error="$v.newTariffPaymentMethod.$error">Quarterly Direct Debit</radio-button>
      </div>

      <div class="col-xs-6 col-md-3">
        <radio-button v-model="quote.newTariffPaymentMethod" value="cashOrCheque"
          :error="$v.newTariffPaymentMethod.$error">Cash & Cheque</radio-button>
      </div>

      <div class="col-xs-6 col-md-3">
        <radio-button v-model="quote.newTariffPaymentMethod" value="prePaymentMeter"
          :error="$v.newTariffPaymentMethod.$error">Prepayment</radio-button>
      </div>
    </div>
  </div>
</template>

<script>
import RadioButton from '../../../../base/components/forms/RadioButton';

import { mapState } from 'vuex';

export default {
  name: 'PaymentTypeNew',
  props: {
    $v: Object
  },
  data() {
    return {
      error: null
    };
  },
  computed: {
    ...mapState({
      quote: ({ quote }) => quote
    })
  },
  methods: {},
  components: {
    RadioButton
  }
};
</script>

<style lang="scss"></style>
